// Function loadprofileDetailBlock loads the profileDetailBlock class by dynamically importing the js on demand if needed

export function loadProfileDetailBlock($parentEl, isList = false) {

	return import(/* webpackChunkName: "wg-profile-detail-block-chunk" */ '../widgets/profileDetailBlock').then(wg => {

		const { ProfileDetailBlock } = wg;

		let $wg = $parentEl.querySelector('[data-wg="ProfileDetailBlock"]');

		if(!$wg) {
			// console.info('ProfileDetailBlock: no widget found');
			return null;
		}

		if (isList) {
			let $wgCol = $parentEl.querySelectorAll('[data-wg="ProfileDetailBlock"]');
			let instances = [];
			$wgCol.forEach(($wg, i) => {
				instances.push( new ProfileDetailBlock($wg) );
			});
			if (instances.length === $wgCol.length) return instances;

		} else {
			return new ProfileDetailBlock($wg);
		}


	}).catch(error => error+'An error occurred while loading the ProfileDetailgBlock widget');

}
